exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".square-progress-ring[data-v-3f0bf46f]{position:relative;display:inline-block}.progress-content[data-v-3f0bf46f]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center}.progress-percentage[data-v-3f0bf46f]{font-size:24px;font-weight:600;color:#303133;line-height:1.2}.progress-status[data-v-3f0bf46f]{font-size:14px;color:#909399;margin-top:4px;line-height:1.2}", ""]);

// exports
